import type { ReactNode } from 'react';
import React, { useEffect } from 'react';
import TryLogIn from './TryLogIn';
import authTokenUtil from '../../account/authTokenUtil';
import localLogout from '../../account/localLogout';
import { useIsNonVisitorUser } from '../../account/useIsLoggedIn';

const LogOut = () => {
  useEffect(() => {
    if (authTokenUtil.get()) {
      localLogout({ preventRedirect: true });
      window.location.reload();
    }
  }, []);
  return null;
};

interface EnsureUserOrAnonymousProps {
  children: ReactNode;
}

const EnsureUserOrAnonymous = ({ children }: EnsureUserOrAnonymousProps) => {
  const isNonVisitorUser = useIsNonVisitorUser();

  if (isNonVisitorUser || !authTokenUtil.get()) {
    return children;
  }

  return <TryLogIn fallback={<LogOut />} />;
};

export default EnsureUserOrAnonymous;
